<template>
  <div class="ws-state-form">
    <v-form
      ref="createForm"
      @submit.prevent
    >
      <div class="ws-content">
        <v-row>
          <v-col
            v-for="(field, fieldKey) in generalFields"
            cols="12"
            :sm="field.sm ? field.sm : 12"
            :key="fieldKey"
          >
            <WsState
              :type="field.type"
              :label="field.label"
              :fields="field.fields"
              :displayLabel="field.displayLabel"
              :rules="field.rules"
              :uploadUrl="field.uploadUrl"
              :autofocus="field.autofocus"
              :getText="field.getText"
              :conditionKeys="field.conditionKeys"
              :hasCloseChips="field.hasCloseChips"
              :items="field.items"
              :defaultValue="field.defaultValue"
              :noReset="field.noReset"
              :modelName="field.modelName"
              :originData="value"
              :originDataEX="modelData"
              :displayCheck="field.displayCheck"
              :textKey="field.textKey"
              :placeholder="field.placeholder"
              :parent="field.parent"
              :requiredField="field.requiredField"
              :activeText="field.activeText"
              :inactiveText="field.inactiveText"
              :orderWay="field.orderWay"
              :orderBy="field.orderBy"
              :note="field.note"
              :maxWidth="field.maxWidth"
              :excludeSelf="field.excludeSelf"
              :maxlength="field.maxlength"
              :modelId="id"
              :errorMessage="$_getErrorMessage(fieldKey)"
              :requiredFieldState="$_getParentState(fieldKey,fields)"
              :originValue="$_getOriginValue(modelData,fieldKey)"
              :conditions="$_getConditions(fieldKey)"
              :parentState="$_getParentState(fieldKey,fields)"
              :parentStateName="field.parentStateName"
              :customParentData="customParentData"
              :clearable="field.clearable"
              :customFunction="field.customFunction"
              :isLink="field.isLink"
              @input="$_onInput(fieldKey,$event)"
              :value="value[fieldKey]"
            />
          </v-col>
        </v-row>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  data: () => ({
    fields: {},
    id: null,
  }),
  props: {
    generalFields: {
      type: Object,
      default() {
        return {};
      },
    },
    arrayList: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: [Object, String, Number],
      default: null,
    },
    detect: {
      type: Boolean,
      default: false,
    },
    modelData: {
      type: Object,
      defualt() {
        return {};
      },
    },
    defaultValue: {
      type: [String, Number],
      default: null,
    },
    customParentData: {
      type: Object,
    },
  },
  computed: {
    _generalFields() {
      const _generalFields = {};
      for (let fieldKey in this.fields) {
        const field = this.fields[fieldKey];
        if (field.type == "locales") {
          continue;
        }
        _generalFields[fieldKey] = field;
      }
      return _generalFields;
    },
    _localeField() {
      let _localeField = null;
      for (let fieldKey in this.fields) {
        const field = this.fields[fieldKey];
        if (field.type == "locales") {
          _localeField = field;
        }
      }
      return _localeField;
    },
    _localeFieldKey() {
      let _localeFieldKey = null;
      for (let fieldKey in this.fields) {
        const field = this.fields[fieldKey];
        if (field.type === "locales") {
          _localeFieldKey = fieldKey;
        }
      }
      return _localeFieldKey;
    },
  },

  methods: {
    $_onInput(fieldKey, $event) {
      let _value = JSON.parse(JSON.stringify(this.value));
      _value = {
        ..._value,
        [fieldKey]: $event,
      };
      this.$emit("input", _value);
    },
    $_getOriginValue(modelData, fieldKey) {
      if (!modelData) {
        return null;
      } else {
        return modelData[fieldKey];
      }
    },
    $_getParentState(fieldKey, fields) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, fields);
      if (!field) {
        return null;
      }
      if (field.parentKey) {
        return this.value[field.parentKey];
      } else if (field.requiredField) {
        if (this.value[field.requiredField]) {
          return this.value[field.requiredField];
        } else if (
          this.customParentData &&
          this.customParentData[field.requiredField]
        ) {
          return this.customParentData[field.requiredField];
        } else if (this.modelData[field.requiredField]) {
          return this.modelData[field.requiredField].id;
        }
      } else {
        return null;
      }
    },
    $_getFieldAttr(fieldKey, keyName) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, this.generalFields);
      if (field) {
        return field[keyName];
      } else {
        return null;
      }
    },
    $_getErrorMessage(fieldKey) {
      if (this.errorMessages) {
        if (this.errorMessages[fieldKey]) {
          return this.errorMessages[fieldKey];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    $_copyfields() {
      this.fields = this.generalFields;
    },
    async $_detect() {
      const isValidate = await this.$refs.form.validate();
      this.$emit("isCompleted", isValidate);
    },
    $_getConditions(fieldKey) {
      if (fieldKey === "locales") return;
      const _conditions = [];
      const conditionKeys = this.$_getFieldAttr(fieldKey, "conditionKeys");
      if (!conditionKeys) {
        return [];
      }
      conditionKeys.forEach((conditionKey) => {
        let _value = "";
        if (this.value[conditionKey.fieldName]) {
          _value = this.value[conditionKey.fieldName];
        } else if (
          this.customParentData &&
          this.customParentData[conditionKey.fieldName]
        ) {
          _value = this.customParentData[conditionKey.fieldName];
        } else if (this.modelData[conditionKey.fieldName]) {
          _value = this.modelData[conditionKey.fieldName].id ? this.modelData[conditionKey.fieldName].id : this.modelData[conditionKey.fieldName];
        } else {
          return;
        }
        _conditions.push({
          key: conditionKey.conditionName,
          value: _value,
          type: conditionKey.type,
        });
      });
      return _conditions;
    },
    $_onDefaultValue() {
      if (this.defaultValue) {
        this.value = this.defaultValue;
      }
    },
  },
  mounted() {
    this.$_copyfields();
    this.$_onDefaultValue();
  },
};
</script>

<style>
</style>